var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalReasoningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#F37122"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84019 10.9956L4.323 6.47837L5.47862 5.32275L8.84019 8.68433L12.1993 5.32275L13.3549 6.47837L8.84019 10.9956Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.51636,
    y: 10.981,
    width: 8.6451,
    height: 1.63549,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalReasoningIcon);
export default __webpack_public_path__ + "static/media/clinicalReasoningIcon.5f06250bed168625c696ebb0900829d5.svg";
export { ForwardRef as ReactComponent };